module.exports = __webpack_public_path__ + "img/hand-shake-mobile.674c6832.png";